import LoginComponent from "@/views/user/auth/LoginView.vue";
import LogoutComponent from "@/views/user/auth/LogoutView.vue";
import RegisterComponent from "@/views/user/auth/RegisterView.vue";
import NotFoundPage from '@/components/user/layout/NotFoundPage.vue';
import DashboardView from "@/views/user/dashboard/DashboardView.vue";
import PackageView from "@/views/user/package/PackageView.vue";
import AppsView from "@/views/user/app/AppsView.vue";
import DevelopersView from "@/views/user/developer/DevelopersView.vue"
import DeveloperListView from "@/views/user/developerList/DeveloperListView.vue";
import NotificationView from "@/views/user/notification/NotificationView.vue";
import PaymentView from "@/views/user/payment/PaymentView.vue";
import EmailVerify from "@/views/user/Email/EmailVerifyView.vue"
import SetEmailVerify from "@/views/user/Email/SetEmailVerify.vue"
import AppListView from "@/views/user/appList/AppListView.vue";
import ProfileView from "@/views/user/profile/ProfileView.vue";
import ResetPassword from "@/views/user/auth/ResetPassword.vue";
import ForgotPassword from "@/views/user/auth/ForgotPassword.vue";
import DeveloperView from "@/views/user/developer/DeveloperView.vue";
import AppView from "@/views/user/app/AppView.vue";
import HistoryView from "@/views/user/history/HistoryView.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
    meta: {
      public: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginComponent,
    meta: {
      public: true,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: LogoutComponent,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterComponent,
    meta: {
      public: true,
      title: "Register",
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardView,
    meta: {
      requiresAuth: true,
      title: ('Dashboard.pageTitle'),
    },
  },
  {
    path: "/apps",
    name: "Apps",
    component: AppsView,
    meta: {
      requiresAuth: true,
      title: ('Apps.pageTitle'),
    },
  },
  {
    path: "/app/:storeId",
    name: "App",
    component: AppView,
    meta: {
      requiresAuth: true,
      title: ('Apps.app')
    },
    props: route => ({ 
      storeId: route.params.storeId, 
      country: route.query.country,
      historyId: route.query.historyId  
    }),
  },
  {
    path: "/app/history/:historyId",
    name: "History",
    component: HistoryView,
    meta: {
      requiresAuth: true,
      title: ('Apps.history')
    },
    props: route => ({ 
      historyId: route.params.historyId, 
    }),
  },
  {
    path: "/appLists",
    name: "AppLists",
    component: AppListView,
    meta: {
      requiresAuth: true,
      title: ('AppLists.pageTitle'),
    },
  },
  {
    path: "/developers",
    name: "Developers",
    component: DevelopersView,
    // props: (route) => ({ id: route.query.id }),
    meta: {
      requiresAuth: true,
      title: ('Developers.pageTitle'),
    },
  },
  {
    path: "/developer/:storeId",
    name: "Developer",
    component: DeveloperView,
    meta: {
      requiresAuth: true,
      title: ('Developers.developer')
    },
    props: route => ({ storeId: route.params.storeId, }),
  },
  {
    path: "/developerLists",
    name: "DeveloperLists",
    component: DeveloperListView,
    meta: {
      requiresAuth: true,
      title: ('DeveloperLists.pageTitle'),
    },
  },
  {
    path: "/packages",
    name: "Packages",
    component: PackageView,
    meta: {
      requiresAuth: true,
      title: ('Package.pageTitle'),
    },
  },
  {
    path: "/developers",
    name: "Developers",
    component: DevelopersView,
    meta: {
      requiresAuth: true,
      title: ('Developers.pageTitle'),
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: NotificationView,
    meta: {
      requiresAuth: true,
      title: ('Notification.pageTitle'),
    },
    state: true,
  },
  {
    path: "/payment",
    name: "Payment",
    component: PaymentView,
    meta: {
      requiresAuth: true,
      title: ('Payment.pageTitle'),
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfileView,
    meta: {
      requiresAuth: true,
      title: ('User.profile'),
    },
  },
  {
    path: "/email-verify",
    name: "EmailVerify",
    component: EmailVerify,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      public: true,
      requiresAuth: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      public: true,
      requiresAuth: false,
    },
  },
  {
    path: "/user/email/verify/:token",  
    name: "SetEmailVerify",
    component: SetEmailVerify,
    meta: {
      public: true,
      requiresAuth: false,
    },
    props: true, 
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFoundPage",
    component: NotFoundPage,
    meta: {
      public: true,
    },
  },
];

export default routes;
